import { ContractDuration, DurationDiscount, PaymentBillingMode } from "../types/licence.definition";

// Percentage the server applies to a contract duration (and, for ONE_YEAR, the chosen
// billing mode), read from GET /licences/duration-discounts. Exact (duration, mode)
// entry first, else the duration's mode-agnostic (duration, null) entry.
export function findDurationDiscountPercentage(
  discounts: DurationDiscount[],
  duration: ContractDuration,
  billingMode?: PaymentBillingMode | null
): number {
  const exact = billingMode
    ? discounts.find((d) => d.contractDuration === duration && d.paymentBillingMode === billingMode)
    : undefined;
  const fallback = discounts.find((d) => d.contractDuration === duration && !d.paymentBillingMode);
  return (exact ?? fallback)?.discountPercentage ?? 0;
}

// Same rounding as the server: discount = round(base × pct / 100) to whole FCFA (half-up),
// amount = base − discount. The percentage is scaled to an integer (2 decimals) first so
// a value like 10.15 % cannot drift through floating-point error before rounding.
export function applyDurationDiscount(base: number, percentage: number): { discount: number; amount: number } {
  const discount = Math.round((base * Math.round(percentage * 100)) / 10000);
  return { discount, amount: base - discount };
}
